export default __webpack_public_path__ + "static/media/ic-conoce-mas.dda6eae9.svg";